import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    errors: []
  },
  reducers: {
    pushErrorNotify: (state, action) => {
      state.errors.unshift({
        id: Date.now(),
        title: action.payload.title,
        message: action.payload.message,
        data: action.payload.data || null,
        createdAt: new Date()
      })
    },
    clearErrorNotify: (state) => {
      state.errors = []
    },
  }
});

export const { pushErrorNotify, clearErrorNotify, addError } = notificationSlice.actions;
export default notificationSlice.reducer;
